import React, { useContext, useState } from "react";
import "./Category.css";
import axios from "axios";
import { useQuery } from "react-query";
import { productContext } from "../../context/Product/ProductContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function Category() {
  const navigate = useNavigate();

  function getAllcategories() {
    return axios.get(`https://vehex-production.up.railway.app/category`);
  }

  let { isError, isLoading, data } = useQuery(
    "getAllcategories",
    getAllcategories
  );
  // async function getAllcategoriesById(id){
  //   let response=await axios.get(`https://vehex-production.up.railway.app/prouctsByCategory/${id}`)
  //   console.log(response)
  // }

  async function getProductsWithSameCategoryid(id) {
    try {
      let response = await axios.get(`https://vehex-production.up.railway.app/product/prouctsByCategory/${id}`);
      // console.log(response.data);
  
      if (response.data.message === "No products found in this category.") {
        toast.success("No products found in this category.", {
          duration: 3000,
          position: "top-center",
        });
      } else {
        navigate("/products", { state: { products: response.data.products } });
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("An error occurred while fetching products.", {
        duration: 3000,
        position: "top-center",
      });
    }
  }

  function gearToggle() {
    let settingsBox = document.getElementById("settings-box");
    let categories = document.getElementById("categories");

    if (settingsBox.classList.contains("open")) {
      settingsBox.classList.remove("open");
      categories.style.width = "0px";
    } else {
      settingsBox.classList.add("open");
      categories.style.width = "250px";
    }
  }
  

  return (
    <>
      <section
        className="left-section categories"
        id="categories"
      >
        <div className="settings-box open" id="settings-box">
          <div className="toggle-settings ">
            <i
              className="fa-solid fa-bars fs-4"
              id="gear"
              onClick={() => gearToggle()}
            ></i>
          </div>
          <div className="item">
            <h3 className=" mx-3 my-2 heading">Categories</h3>
            <ul className="mt-3 p-0">
              {data?.data.categories?.map((category) => (
                <li
                  className="px-3 py-2 text-white position-relative"
                  key={category._id}
                  onClick={() => getProductsWithSameCategoryid(category._id)}
                >
                  {category.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
